import PropTypes from 'prop-types'

export const TilePropTypes = PropTypes.shape({
  image: PropTypes.string.isRequired,
  contentItem: PropTypes.shape({
    __typename: PropTypes.string.isRequired
  }).isRequired,
  badge: PropTypes.string
})
